var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu'),_c('div',{staticClass:"container main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('SectionTitle',{attrs:{"title":"Resultado Municipal","description":"Cidadãos e classificação por equipe no vínculo e acompanhamento.","url":"/dashboard"}})],1)]),_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }